/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Not_Comparable_BodyInputs */

const en_us2_body_assessment_not_comparable_body = /** @type {(inputs: Body_Assessment_Not_Comparable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The conditions in these photos depart from the protocol, so this number stays out of your trend. Retake them following the tips and it counts again.`)
};

const pt_br2_body_assessment_not_comparable_body = /** @type {(inputs: Body_Assessment_Not_Comparable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As condições destas fotos fogem do protocolo, então este número fica fora da sua evolução. Refaça seguindo as dicas e ele volta a contar.`)
};

const es_419_body_assessment_not_comparable_body = /** @type {(inputs: Body_Assessment_Not_Comparable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las condiciones de estas fotos se salen del protocolo, así que este número queda fuera de tu evolución. Vuelve a tomarlas siguiendo los consejos y vuelve a contar.`)
};

const pt_pt2_body_assessment_not_comparable_body = /** @type {(inputs: Body_Assessment_Not_Comparable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As condições destas fotos fogem ao protocolo, por isso este número fica fora da tua evolução. Repete-as seguindo as dicas e ele volta a contar.`)
};

const fr_fr2_body_assessment_not_comparable_body = /** @type {(inputs: Body_Assessment_Not_Comparable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les conditions de ces photos s'écartent du protocole, donc ce chiffre reste hors de ton évolution. Reprends-les en suivant les conseils et il comptera de nouveau.`)
};

const de_de2_body_assessment_not_comparable_body = /** @type {(inputs: Body_Assessment_Not_Comparable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Bedingungen dieser Fotos weichen vom Protokoll ab, daher bleibt diese Zahl außerhalb deines Verlaufs. Mach sie nach den Tipps neu, dann zählt sie wieder.`)
};

const it_it2_body_assessment_not_comparable_body = /** @type {(inputs: Body_Assessment_Not_Comparable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le condizioni di queste foto si discostano dal protocollo, quindi questo numero resta fuori dal tuo andamento. Rifalle seguendo i consigli e tornerà a contare.`)
};

/**
* | output |
* | --- |
* | "The conditions in these photos depart from the protocol, so this number stays out of your trend. Retake them following the tips and it counts again." |
*
* @param {Body_Assessment_Not_Comparable_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_not_comparable_body = /** @type {((inputs?: Body_Assessment_Not_Comparable_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Not_Comparable_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_not_comparable_body(inputs)
	if (locale === "es-419") return es_419_body_assessment_not_comparable_body(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_not_comparable_body(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_not_comparable_body(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_not_comparable_body(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_not_comparable_body(inputs)
	return en_us2_body_assessment_not_comparable_body(inputs)
});
export { body_assessment_not_comparable_body as "body-assessment.not_comparable_body" }